module.exports = __webpack_public_path__ + "img/fire_pink.5569db2.svg";